import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Navigation } from './components/Navigation';
import { ContentSection } from './components/ContentSection';
import { AnimatedBackground } from './components/AnimatedBackground';
import { Footer } from './components/footer/Footer';

// Lazy load TravelDirection component
const TravelDirection = React.lazy(() => import('./pages/TravelDirection').then(module => ({
  default: module.TravelDirection
})));

function App() {
  return (
    <Router basename="/disha-shool">
      <Helmet>
        <title>दिशा शूल - यात्रा के लिए शुभ दिशा जानें | Disha Shool</title>
        <meta name="description" content="दिशा शूल (Disha Shool) - यात्रा के लिए शुभ दिशा जानें। हर दिन की शुभ और अशुभ दिशाओं की जानकारी प्राप्त करें।" />
      </Helmet>

      <div className="min-h-screen flex flex-col">
        <Navigation />

        <main className="flex-grow relative">
          <AnimatedBackground />
          <Routes>
            <Route path="/" element={<ContentSection />} />
            <Route path="/travel-direction" element={
              <Suspense fallback={
                <div className="min-h-screen flex items-center justify-center">
                  <div className="animate-spin rounded-full h-32 w-32 border-t-2 border-b-2 border-purple-500"></div>
                </div>
              }>
                <TravelDirection />
              </Suspense>
            } />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}

export default App;